import { Box, Flex } from "@chakra-ui/react";
import { FC, useContext, useEffect, useRef, useState } from "react";
import { Data } from "./types/TypeData";
import { Model } from "./DataCard/Model/Model";
import { motion } from 'framer-motion';
import styles from ".././css/nonScrollbar.module.scss"
import { ModalContext, RenderContext } from "./CreateContext";

type Props = {
    moveData: Data[]
    i: number
}

export const Layout1: FC<Props> = (props) => {
    const { moveData, i } = props;
    const { settings } = useContext(RenderContext);
    const containerRef = useRef<HTMLDivElement>(null);
    const [isScrollPaused, setScrollPaused] = useState(false);
    const [canRestartScroll, setCanRestartScroll] = useState(true);
    const { setRerender } = useContext(RenderContext);
    const { isModalOpen } = useContext(ModalContext);
    const [RenderTimes, setRenderTimes] = useState(1)
    let itemlength = Math.floor(moveData.length / 3);

    const snapLifeTime = settings.find(setting => setting.KEY_NAME === "snap_life_time");
    const lifeTime = typeof snapLifeTime?.VALUE === "number" ? snapLifeTime.VALUE : 8

    useEffect(() => {
        if (i === 0) {
            if (moveData.length % 3 > 0) {
                itemlength = Math.floor(moveData.length / 3) + 1;
            }
        }
        if (i === 1) {
            if (containerRef.current) {
                containerRef.current.scrollTop = containerRef.current.scrollHeight - window.innerHeight;
            }
            if (moveData.length % 3 === 2) {
                itemlength = Math.floor(moveData.length / 3) + 1;
            }
        }
    }, [containerRef.current?.scrollHeight]);

    const useSnapScroll = (totalItems: number) => {
        const [currentIndex, setCurrentIndex] = useState(0);

        useEffect(() => {
            const interval = setInterval(() => {
                if (!isScrollPaused && !isModalOpen) {
                    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalItems);
                }
            }, lifeTime * 1000);
            // 8秒後にスナップ(詳細画面が開いていたら作動しない)
            const handleMouseMove = () => {
                setScrollPaused(true);
                clearInterval(interval);
            };

            const handleTouchStart = () => {
                setScrollPaused(true);
                clearInterval(interval);
                setCanRestartScroll(true);
            };

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('touchstart', handleTouchStart);

            return () => {
                clearInterval(interval);
            };
        }, [isModalOpen, isScrollPaused, itemlength]);

        return currentIndex;
    };

    let currentIndex = useSnapScroll(itemlength);
    if (i === 1) {
        currentIndex = itemlength - currentIndex;
    }

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            const targetElement = container.children[currentIndex] as HTMLElement;
            if (targetElement) {
                const rect = targetElement.getBoundingClientRect();
                const scrollTop = window.innerHeight > window.innerWidth ?
                    rect.top + container.scrollTop - containerRef.current?.getBoundingClientRect().top - (window.innerHeight * 0.195) :
                    rect.top + container.scrollTop - containerRef.current?.getBoundingClientRect().top;
                const scrollBottom = rect.bottom - containerRef.current.getBoundingClientRect().bottom + container.scrollTop;
                if (i === 1) {
                    container.scrollTo({
                        top: scrollBottom,
                        behavior: 'smooth',
                    });
                    if (currentIndex == 1) {
                        setRenderTimes(RenderTimes + 1)
                        RenderTimes % 3 == 0 && setRerender(false)
                    }
                } else {
                    container.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth',
                    });
                }
            }
        }
    }, [currentIndex]);

    useEffect(() => {
        if (canRestartScroll) {
            const restartTimeout = setTimeout(() => {
                setScrollPaused(false);
                setCanRestartScroll(false);
            }, 2000);
            // タッチしたら2+8秒後にスナップ
            return () => clearTimeout(restartTimeout);
        }
    }, [canRestartScroll]);

    return (
        <div
            id={i.toString()}
            ref={containerRef}
            className={styles.nonScrollbar}
            style={{
                overflowY: 'scroll',
                overflowX: 'hidden',
                height: `${window.innerHeight}px`,
                scrollBehavior: 'smooth',
            }}
        >
            {window.innerHeight > window.innerWidth && <div style={{ margin: `${window.innerHeight * 0.195}px` }}></div>}
            {moveData.map((data, index) => (
                index % 3 === i && (
                    <motion.div key={data.TOPIC_ID} style={{ touchAction: "pan-y" }}>
                        <Model
                            Title={data.TOPIC_TITLE}
                            Medias={data.MEDIAS}
                            WallLikes={data.WALL_LIKES}
                            TopicAuthorName={data.TOPIC_AUTHOR_NAME}
                            TopicBody={data.TOPIC_BODY}
                            CategoryID={data.CATEGORY_ID}
                            TopicID={data.TOPIC_ID}
                        />
                    </motion.div>
                )
            ))}
            <div style={{ margin: '60px' }}></div>
        </div>
    );
};
